// @flow
import React, { type Node } from 'react';

import styled from 'styled-components';
import { ApolloProvider } from '@apollo/client';
import { Fill } from 'layout-core-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BKToolsErrorBoundary from './BKToolsErrorBoundary';
import graphqlClient from './graphqlClient';
import SidebarDismissBypassingCloseButton from './SidebarDismissBypassingCloseButton';
import getClientId from './getClientId';

const GlobalStyleWrapper = styled.div`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`;

const BkWebApp = (props: { children: Node, isToastContainerApp: boolean }) => (
  <ApolloProvider client={graphqlClient}>
    <Fill to="parent">
      <BKToolsErrorBoundary clientId={getClientId()}>
        <GlobalStyleWrapper>
          {props.children}
          {props.isToastContainerApp && (
            <ToastContainer
              closeButton={<SidebarDismissBypassingCloseButton />}
              hideProgressBar
              position="bottom-right"
            />
          )}
        </GlobalStyleWrapper>
      </BKToolsErrorBoundary>
    </Fill>
  </ApolloProvider>
);

BkWebApp.defaultProps = {
  isToastContainerApp: false,
};

export default BkWebApp;
